export class Oui_TypeOuiNonInformComplementaire {

	public visiteDetail: string;

	constructor() { 
		 		this.visiteDetail = '';
 
	}
}
